import api from './api';

// Applications + landing pages waiting on Team365 (Jenn, 2026-10-07).
export const getWaiting = () => api.get('/admin/affiliates/waiting').then(r => r.data);
export const approveApplication = (id) => api.post(`/admin/affiliates/applications/${id}/approve`).then(r => r.data);
export const declineApplication = (id) => api.post(`/admin/affiliates/applications/${id}/decline`).then(r => r.data);
